module.exports = __webpack_public_path__ + "static/budweiser-2d8aba6f62cbbe569e8185a1c50cd431.svg";